/* eslint-disable react/no-danger */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  isOpen: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  osvStatement: string | null;
}

const ConfirmModal = ({ isOpen, handleClose, onConfirm, osvStatement }: ConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth>
      <DialogTitle>{t('Are you sure?', { defaultValue: 'Are you sure?' })}</DialogTitle>
      {osvStatement ? (
        <DialogContent sx={{ pt: 0 }}>
          <div dangerouslySetInnerHTML={{ __html: osvStatement }} />
        </DialogContent>
      ) : (
        <DialogContent sx={{ pt: 0 }}>
          <Typography
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.grey[700],
            })}
          >
            {t('You confirm that you provided true information?', {
              defaultValue: 'You confirm that you provided true information?',
            })}
          </Typography>
        </DialogContent>
      )}

      <DialogActions>
        <Button onClick={handleClose}>
          {t('Deny statement', { defaultValue: 'Deny statement' })}
        </Button>
        <Button onClick={onConfirm}>
          {t('Accept statement', { defaultValue: 'Accept statement' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
